export default "__VITE_ASSET__D4TvI4q7__"